export const REVIEW_EMAIL = 'appreview@taka.ai';
export const REVIEW_OTP = '555555';
export const ACCESS_TOKEN_KEY = 'accessToken';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const PENDING_BUSINESS_ID = '-1';
export const INVALID_CODE_ERROR = 'Invalid verification code';
export const VERIFICATION_FAILED_ERROR = 'Verification Failed';
export const SEND_CODE_FAILED_ERROR = 'Failed to send verification code';
export const FAILED_TO_VERIFY_ERROR = 'Failed to verify code';
export const SESSION_EXPIRED_ERROR = 'Session expired';
export const REFRESH_FAIL_COUNT_KEY = 'refreshFailCount';
//# sourceMappingURL=authentication.const.js.map